import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from './card';
import '../styles/projects.css';
import projectData from '../utils/projectData.js';

const Projects = (props,{id}) => {
  const [showMore, setShowMore] = useState(false);
  const cardsToShow = showMore ? projectData : projectData.slice(0, 3);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="projects-projects" id="projects">
      <h1 className="projects-text">{props.heading}</h1>
     
        {cardsToShow.map((project, index) => ( <div className="projects-container">
          <Card
            key={index}
            ClassName="rootClassName1"
            label={project.label}
            title={project.title}
            description={project.description}
            imageSrc={project.image}
            url={project.url}
            icons={project.icon}
          />
          </div>
        ))}
      
      
      {projectData.length > 3 && (
        <a onClick={toggleShowMore}  className="projects-link">
          {showMore ? 'Show Less' : 'See More'}
        </a>
      )}
     
    </div>
  );
};

Projects.defaultProps = {
  heading: 'MY PROJECTS',
  text: 'View More',
  linkText: 'https://example.com',
};

Projects.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  linkText: PropTypes.string,
};

export default Projects;
